//@flow
import React, {useMemo} from 'react';
import {Notifications} from '@material-ui/icons';
import NotificationsMenuContainer from '../../modules/store-notifications/components/NotificationsMenu/container/NotificationsMenuContainer';
import {Badge, IconButton} from '@material-ui/core';
import {connect} from 'react-redux';

import type {StoreNotification} from '../../entities';
import type {RootState} from '../../modules';

export default connect(
  (state: RootState) => ({
    unseenNotifications: state.notifications.unseenNotifications,
  }),
  null
)(ActionAppBarNotificationsButton);

type Props = {|
  unseenNotifications?: StoreNotification[],
|};

function ActionAppBarNotificationsButton(props: Props) {
  const {unseenNotifications} = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const notSeenNumber = useMemo(() => {
    if (unseenNotifications && unseenNotifications.length)
      return unseenNotifications.length;
  }, [unseenNotifications]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Badge
          badgeContent={notSeenNumber}
          color="primary"
          overlap="rectangular"
        >
          <Notifications />
        </Badge>
      </IconButton>
      <NotificationsMenuContainer
        anchorEl={anchorEl}
        handleClose={handleClose}
      />
    </>
  );
}
